import React from "react";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { IconButton, Grid } from "@material-ui/core";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { useOrderIndFilter, useCurrentOrderIndFilter } from "../../../data/trading/orderIndicative/hooks/useOrderFilter";
import { OrderIndFilterChips } from "./OrderIndFilterChips";
import { OrderIndFilterEditor } from "./OrderIndFilterEditor";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const OrderIndFilterButton: React.FunctionComponent = () => {
	const showWithDrawer = React.useContext(DisplayDrawerContext);
	const showFilter = React.useCallback(() => showWithDrawer(<OrderIndFilterDrawer />), [showWithDrawer]);

	const theme = useTheme();
	const screenExtraSmall = useMediaQuery(theme.breakpoints.only('xs'));

	const [filter, remnoveFilter] = useCurrentOrderIndFilter();

	return (
		<Grid container alignItems="center" spacing={2}>
			<Grid item>
				<OrderIndFilterChips filter={filter} remnoveFilter={remnoveFilter} />
			</Grid>
			<Grid item>
				<CustomTooltip titleKeyword="filterTooltip">
					<IconButton color={!screenExtraSmall || Object.keys(filter).length===0 ? "secondary" : "primary" } component="span" onClick={showFilter}>
						<FilterIcon />
					</IconButton>
				</CustomTooltip>
			</Grid>
		</Grid>
	);
};


const OrderIndFilterDrawer: React.FunctionComponent = () => {
	const [filter, editFilter, save, , reset] = useOrderIndFilter();

	return <OrderIndFilterEditor filter={filter} editFilter={editFilter} save={save} reset={reset} />;
};
